export const KNOWN_MEDIA_TYPES = {

    WIKI: {
        key:"WIKI",
        regex: new RegExp("\.wikipedia.org/wiki/")
    },

    PDF: {
        key:"PDF",
        regex: new RegExp("\.pdf$")
    },

    GROK: {
        key:"GROK",
        regex: new RegExp("grokipedia.com/page")
    },

    UNKNOWN: {
        key:"UNKNOWN",
    },

}
